import request from '@/utils/request';

const path = 'api/v1';

const trackingInfo = (data) => request({
  url: `${path}/incoOrderDetail/BySubNo`,
  method: 'get',
  params: data
});

export {
  trackingInfo,
}
